module.exports = __webpack_public_path__ + "img/00004.f0d3fba2.webp";